<script>
export default {
  name: 'VKVideo',
  props: { link: { type: String, default: '' } },
}
</script>

<template>
  <div v-if="link">
    <iframe
      :src="link"
      width="100%"
      height="480"
      allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>
